import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { observable } from 'mobx';
import { FlightsShoppingPwaFlightSearchResultsFlightsSearch } from '__generated__/api';
import ListingsHeaderPlacards = FlightsShoppingPwaFlightSearchResultsFlightsSearch.ListingsHeaderPlacards;

export class ListingsHeaderPlacardsStore extends Store {
  @observable public listingsHeaderPlacards: ListingsHeaderPlacards[];

  public hydrate(data: SerializedData): void {
    if (data) {
      Object.assign(this, data);
    }
  }
}

ListingsHeaderPlacardsStore.DEFAULTS = {};
